import React, { useContext, useEffect, useState } from "react";
import { Formik, Form, Field } from "formik";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import gif from "../assets/new.gif";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { CourseWiseStepsContext } from "../App";
import { BsCalendarDate } from "react-icons/bs";
import { useDispatch, useSelector } from "react-redux";
import { hideLoader, showLoader } from "../Slices/LoaderSlice";
import LogoLoader from "./LogoLoader";

function NewsPage() {
  const [allNews, setAllNews] = useState([]);
  const [filteredNews, setFilteredNews] = useState([]);
  const { setStep } = useContext(CourseWiseStepsContext);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { isLoading } = useSelector((state) => state.loader);
  console.log("isLoading", isLoading)
  const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    fetchNews();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchNews = async () => {
    dispatch(showLoader());
    await sleep(500); // 👈 Force delay so loader is visible
    axios
      .get(`api/v1/get_all_news`)
      .then((res) => {
        setAllNews(res?.data?.news);
        setFilteredNews(res?.data?.news);
      })
      .catch((err) => {
        console.log(err);
      }).finally(() => {
        dispatch(hideLoader());
      });
  };

  const isWithinLast7Days = (dateString) => {
    const givenDate = new Date(dateString);
    const today = new Date();
    const diffInDays = (today - givenDate) / (1000 * 60 * 60 * 24);
    return diffInDays >= 0 && diffInDays < 7;
  };
  const [isfilterhit, setIsfilterhit] = useState(false);
  return (
    <div className="bg-gray-50 w-full min-h-screen">
      {/* <Navbar /> */}
      {isLoading && <LogoLoader />}
      <div className="flex flex-col items-center py-10 px-4 min-h-screen">
        <h1 className="text-4xl font-semibold text-primary mb-10">
          📰 News & Updates
        </h1>

        {/* Formik Filter */}
        <Formik
          initialValues={{ college: "", course: "" }}
          onSubmit={(values) => {
            const filtered = allNews.filter(
              (news) =>
                (values.college === "" ||
                  news.college_name === values.college) &&
                (values.course === "" || news.course_name === values.course)
            );
            filtered?.length > 0 && setIsfilterhit(true);
            setFilteredNews(filtered);
          }}
        >
          {({ values, setFieldValue, handleSubmit, resetForm }) => (
            <Form className="grid md:grid-cols-3 grid-cols-1 md:max-w-lg md:gap-4 gap-2 mb-6">
              <Field
                as="select"
                name="college"
                className="p-2 border-2 border-primary rounded-md"
              >
                <option value="">All Colleges</option>
                {[...new Set(allNews.map((news) => news.college_name))].map(
                  (college) => (
                    <option key={college} value={college}>
                      {college}
                    </option>
                  )
                )}
              </Field>
              <Field
                as="select"
                name="course"
                className="p-2 border-2 border-primary rounded-md"
              >
                <option value="">All Courses</option>
                {[...new Set(allNews.map((news) => news.course_name))].map(
                  (course) => (
                    <option key={course} value={course}>
                      {course}
                    </option>
                  )
                )}
              </Field>
              <button
                type="submit"
                className="px-4 py-2 bg-primary text-white rounded-md"
                onClick={handleSubmit}
              >
                Filter
              </button>
              {isfilterhit && (
                <button
                  type="button"
                  className="px-4 py-2 bg-primary text-white rounded-md"
                  onClick={() => {
                    setFilteredNews(allNews);
                    resetForm();
                    setIsfilterhit(false);
                  }}
                >
                  Clear
                </button>
              )}
            </Form>
          )}
        </Formik>
        <div className="w-full max-w-7xl">
          {filteredNews.length === 0 ? (
            <div className="text-center text-gray-600 text-lg font-medium py-10">
              No news available at the moment! Stay tuned for updates.
            </div>
          ) : (
            [
              ...new Set(filteredNews?.map((newsItem) => newsItem?.college_id)),
            ].map((collegeId) => {
              const collegeNews = filteredNews.filter(
                (newsItem) => newsItem.college_id === collegeId
              );
              const collegeName = collegeNews[0]?.college_name;

              const courseGroups = collegeNews.reduce((acc, newsItem) => {
                acc[newsItem.course_name] = acc[newsItem.course_name] || [];
                acc[newsItem.course_name].push(newsItem);
                return acc;
              }, {});

              return (
                <div
                  key={collegeId}
                  className="bg-white shadow-md rounded-lg p-6 mb-8 border-l-4 border-primary"
                >
                  <h2 className="text-2xl font-semibold text-primary mb-4 capitalize">
                    {collegeName}
                  </h2>

                  {Object.entries(courseGroups).map(
                    ([courseName, newsItems]) => (
                      <div key={courseName} className="mb-6">
                        <h3 className="text-lg font-medium text-secondary mb-3 capitalize">
                          {courseName}
                        </h3>
                        <ul className="space-y-4">
                          {newsItems.map((news) => (
                            <li
                              key={news.id}
                              className="bg-gray-100 hover:bg-gray-200 p-4 rounded-lg transition-all duration-200 cursor-pointer shadow-sm border border-gray-300"
                              onClick={() => {
                                setStep((prevStep) =>
                                  prevStep.map((item) => ({
                                    ...item,
                                    [Object.keys(item)[1]]:
                                      item.name === "News",
                                  }))
                                );
                                navigate(
                                  `/academics/${news.college_id}/${news.course_name}/${news.course_id}`
                                );
                              }}
                            >
                              <div className="flex sm:flex-row flex-col sm:items-center sm:justify-between">
                                <div className="flex sm:justify-start sm:items-end justify-start items-start">
                                  <p className="text-primary text-lg font-semibold">
                                    {news.description}
                                  </p>
                                  {isWithinLast7Days(news.created_at) && (
                                    <img src={gif} alt="New" className="" />
                                  )}
                                </div>
                                <div className="text-gray-500 flex items-center gap-2">
                                  <BsCalendarDate />
                                  {new Date(news?.created_at)
                                    .toISOString()
                                    .split("T")[0]
                                    ?.split("-")
                                    .reverse()
                                    .join("/")}
                                </div>
                              </div>
                              <div className="flex sm:flex-row flex-col gap-2 mt-3">
                                <span className="px-3 py-1 text-xs font-semibold bg-primary text-white rounded-full capitalize">
                                  {news.college_name}
                                </span>
                                <span className="px-3 py-1 text-xs font-semibold bg-secondary/40 text-white rounded-full capitalize">
                                  {news.course_name}
                                </span>
                              </div>
                            </li>
                          ))}
                        </ul>
                      </div>
                    )
                  )}
                </div>
              );
            })
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default NewsPage;
